import { useLocation } from 'react-router-dom';

import Navbar from './Navbar';

/**
 * Public routes get no navigation.
 *
 * `/c/:shortId` and `/s/:shortId` are seen by whoever scans a code — usually
 * someone with no relationship to this dashboard. Showing them Dashboard /
 * Generate / QR Codes links would advertise the admin tool to strangers.
 */
const PUBLIC_PREFIXES = ['/c/', '/s/'];

const AppChrome = () => {
  const { pathname } = useLocation();
  const isPublic = PUBLIC_PREFIXES.some((prefix) => pathname.startsWith(prefix));

  return isPublic ? null : <Navbar />;
};

export default AppChrome;
